import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from "react";
import { gsap } from "gsap";
import "./BonusAnimate.scss";

// import lid_closed from "../assets/bonus/Asset 6@3x.png";
// import box_base from "../assets/bonus/box open-1@3x.png";
import box_base from "../../../../../../assets/games/slots/Corsairs_Treasure/BonusBoxClose.png";
import lid_open from "../../../../../../assets/games/slots/Corsairs_Treasure/BonusBoxOpen.png";
import confetti from "canvas-confetti";
import Howlersounds from "../../../../Utillitys/slotshowlersounds"
import win from "../../../../../../assets/games/slots/CommanAssets/win_icon.png"
import balance from "../../../../../../assets/games/slots/CommanAssets/coins_bln.png"
import profile from '../../../../../../assets/games/slots/CommanAssets/userid.png';

const TreasureBoxGame = forwardRef(({ BonusBoxGameClosepopup, BonusActiveCall, winningBonusAmount, muteSoundStatus , balanceCT, userName  }, ref) => {
    const howlerRef = useRef(null);
    const [clickedBox, setClickedBox] = useState(null);
    const [winAmountBonus, setWinAmount] = useState(0);
    const clickedBoxRef = useRef(null);

    const boxRef = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const lidRef = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const openLidRef = [useRef(null), useRef(null), useRef(null), useRef(null)];


    const msgRef = useRef(null);
    const amountRef = useRef(null);
    const grandLightRef = useRef(null);
    const BoxesCount = [0, 1, 2, 3]


    // INITIAL RANDOM WINNER
    useEffect(() => {
        BoxesCount.map((res, index) => {
            gsap.fromTo(
                boxRef[index].current,
                { scale: 1, opacity: 1, y: 0 },
                {
                    scale: 1.05,
                    opacity: 1,
                    y: -10,
                    duration: 2.5,
                    ease: "power1.inOut",
                    yoyo: true,
                    repeat: -1
                }
            );
        })
    }, []);

    // X + Y SHAKE ANIMATION
    const animateShake = (element, strong = false) => {
        gsap.fromTo(
            element,
            { x: 0, y: 0 },
            {
                x: strong ? "+=10" : "+=6",
                y: strong ? "-=10" : "-=6",
                duration: 0.010,
                repeat: 20,
                yoyo: true,
                ease: "power1.inOut",
            }
        );
    };

    const handleClick = (index) => {
        if (clickedBox !== null) return;
        howlerRef.current?.playSound("bonusStart");
        clickedBoxRef.current = index;   // 💥 immediate update

        BonusActiveCall(index)
        setClickedBox(index);

        animateShake(boxRef[index].current, false);
    };
    useImperativeHandle(ref, () => ({
        WinsBonusBoxOpen(winAmount) {
            let isWinner = Number(winAmount) > 0
            let index = clickedBoxRef.current
            console.log("Clicked Box:", clickedBoxRef.current);
            console.log(index)

            gsap.to(lidRef[index].current, { opacity: 0, duration: 0.3 });
            gsap.to(openLidRef[index].current, {
                opacity: 1,
                scale: 1.1,
                duration: 0.5,
            });

            if (isWinner) {
                runGrandLighting();
                animateAmountFromBox(index);
                blustingEffect()
                setWinAmount(winAmount);
                setTimeout(() => {
                    BonusBoxGameClosepopup(false)
                    confetti.reset(); // stop & clear all confetti canvases
                    gsap.killTweensOf("*"); // kill all active GSAP tweens
                }, 3000)
            } else {
                gsap.to(msgRef.current, {
                    opacity: 1,
                    y: -20,
                    duration: 1,
                });
                setTimeout(() => {
                    BonusBoxGameClosepopup(false)
                    confetti.reset(); // stop & clear all confetti canvases
                    gsap.killTweensOf("*"); // kill all active GSAP tweens
                }, 2000)
            }
        }
    }))


    // WIN AMOUNT ANIMATION (EXPLOSION → MOVE TO TOP)
    const animateAmountFromBox = (index) => {
        const boxEl = boxRef[index].current;
        const amountEl = amountRef.current;

        const rect = boxEl.getBoundingClientRect();

        const startX = rect.left + rect.width / 2 - 30;
        const startY = rect.top + rect.height / 2;

        gsap.set(amountEl, {
            x: startX,
            y: startY,
            opacity: 0,
            scale: 0.3,
        });

        // ⭐ COIN EXPLOSION STYLE
        gsap.to(amountEl, {
            opacity: 1,
            scale: 1.4,
            // x: window.innerWidth/2,
            y: startY - 228,
            duration: 0.45,
            ease: "back.out(1.7)",
        });

        // ⭐ Move to top center
        gsap.to(amountEl, {
            delay: 0.45,
            // x: window.innerWidth/2 ,
            y: 180,
            scale: 1.5,
            duration: 1,
            ease: "power2.out",
        });

        // ⭐ Glow pulse
        gsap.to(amountEl, {
            textShadow: "0 0 30px gold",
            repeat: -1,
            yoyo: true,
            duration: 0.9,
        });
    };

    // GRAND LIGHT EFFECT (PREMIUM)
    const runGrandLighting = () => {
        const light = grandLightRef.current;

        gsap.set(light, { opacity: 0, scale: 0.2, rotate: 0 });

        gsap.to(light, {
            opacity: 1,
            scale: 1.4,
            duration: 0.7,
            ease: "power3.out",
        });

        gsap.to(light, {
            rotate: 360,
            repeat: -1,
            duration: 2.8,
            ease: "linear",
        });
    };
    const blustingEffect = () => {
        howlerRef.current?.playSound("bonusWin");
        const duration = 2500;
        const end = Date.now() + duration;
        confetti({
            particleCount: 1000,
            spread: 180,
            startVelocity: 60,
            origin: { y: 0.7 },
            colors: ["#ffcc00", "#ff6600", "#ffffff"],
        });

        (function frame() {
            confetti({
                particleCount: 20,
                startVelocity: 15,
                spread: 360,
                ticks: 30,
                origin: { x: Math.random(), y: Math.random() - 0.2 },
            });
            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        })();
    }
    return (
        <>
            <Howlersounds ref={howlerRef} mutesounds={muteSoundStatus} />
            <div className="main_div_BonusCT">
                <div>
                    <div className="balance_winDivBCT">
                        <div className="text-center balance_section BGM_CT_profileBar">
                            <img src={balance} alt="" className="imgbtnCT upsectionCT" />
                            <p className="amt_numCT">{balanceCT.toFixed(2)}</p>
                        </div>
                        <div></div>
                        <div className="btwn_space_bln">
                            <div className="text-center balance_section BGM_CT_profileBar">
                                <img src={win} alt="" className="imgbtnCT upsectionCT" />
                                <p className="amt_numCT">{winAmountBonus}</p>
                            </div>
                            <div className="text-center balance_section BGM_CT_profileBar">
                                <img src={profile} alt="" className="imgbtnCT upsectionCT" />
                                <p className="amt_numCT">{userName}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gameWrapper Bonus_BG_CT">
                    <div ref={grandLightRef} className="grand-light"></div>

                    {/* Rising WIN AMOUNT */}
                    <div ref={amountRef} className="amount-text">
                        ₹{winAmountBonus}
                    </div>

                    {/* LOSER MESSAGE */}
                    <div ref={msgRef} className="lose-text">
                        Better Luck Next Time
                    </div>

                    <div className="box-row">
                        {BoxesCount.map((i) => (
                            <div
                                key={i}
                                ref={boxRef[i]}
                                className="box-wrap"
                                onClick={() => handleClick(i)}
                            >
                                {/* <img ref={lidRef[i]} src={lid_closed} className="lid-img" /> */}
                                <img ref={lidRef[i]} src={box_base} className="box-img" />
                                <img ref={openLidRef[i]} src={lid_open} className="open-lid-img" />
                            </div>
                        ))}
                    </div>
                    <div className="select_one_div">
                        <h2>Select One box</h2>
                    </div>
                </div>
            </div>
        </>
    );
});

export default TreasureBoxGame;
